export const environment = {
  production: true,
  baseApiUrl: '${API_URL}',
  version:  '${APP_VER}'
};
